const LOCALHOST_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);

const sanitizeEnvValue = (value) => value?.trim().replace(/^['"]|['"]$/g, "");

const isLocalhost = (hostname) => LOCALHOST_HOSTNAMES.has(hostname);

export const getGoogleRedirectUri = () => {
  const fallback = new URL("/auth/google/callback", window.location.origin).toString();
  const configuredRedirectUri = sanitizeEnvValue(process.env.REACT_APP_GOOGLE_REDIRECT_URI);

  if (!configuredRedirectUri) {
    return fallback;
  }

  try {
    const configuredUrl = new URL(configuredRedirectUri);
    const runtimeUrl = new URL(fallback);

    if (configuredUrl.origin === runtimeUrl.origin) {
      return configuredUrl.toString();
    }

    // In local/dev we trust the current browser origin over a stale env port.
    if (isLocalhost(configuredUrl.hostname) || isLocalhost(runtimeUrl.hostname)) {
      return fallback;
    }

    return configuredUrl.toString();
  } catch {
    return fallback;
  }
};

export const getGoogleAuthUrl = () => {
  const clientId = sanitizeEnvValue(process.env.REACT_APP_GOOGLE_CLIENT_ID);

  if (!clientId) {
    throw new Error("Google client ID is not configured.");
  }

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: getGoogleRedirectUri(),
    response_type: "code",
    scope: "openid email profile",
    access_type: "offline",
    prompt: "consent",
  });

  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};
